import { render, staticRenderFns } from "./listAttendanceCorrectionComponent.vue?vue&type=template&id=39a1fa1e&"
import script from "./listAttendanceCorrectionComponent.vue?vue&type=script&lang=js&"
export * from "./listAttendanceCorrectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports